<script lang="ts" setup>
import {useCategoriesByPath} from "~/composables/useCategories";

const props = defineProps<{
  categoryRootLink: string;
  categoryId?: string;
}>();

const route = useRoute();
const emit = defineEmits(['handleCategoryFilter']);
const categories = await useCategoriesByPath(props.categoryRootLink);

const handleCategoryFilter = async (id: string) => {
  // Reset pagination to path only
  await navigateTo({
    path: route.fullPath,
  });
  const filterId = id === props.categoryId ? '' : id;
  emit('handleCategoryFilter', filterId);
}
</script>

<template>
  <div class="category-filters flex flex-col lg:flex-row gap-2 lg:gap-4 mb-16" v-if="categories">
    <h3 class="py-3 pe-3">{{ $t('label.categories') }}:</h3>
    <div class="flex gap-2 lg:gap-4 flex-wrap lg:flex-nowrap">
      <button class="p-3 hover:bg-black hover:text-white transition-colors duration-300"
              type="button" v-for="(category, index) in categories"
              :class="categoryId === category['@id'] ? 'bg-black text-white' : 'bg-neutral-100'"
              :key="index" @click="handleCategoryFilter(category['@id'])"><span>{{ category.displayName }}</span></button>
    </div>
  </div>
</template>